import Vue from 'vue';
import App from './App.vue';

// 接口请求
import http from '@/fetch';

import router from './router';
import store from './store';
import VueCookies from 'vue-cookies';

// 引入全局组件
import globalComponents from '@/common/globalComponents';
// 引入公共mixin
import commonMixinx from '@/mixins/common';
// 引入公共数据方法
import common from '@/common';
// iframe 内嵌 应用改造
import { initMicroApp } from '@/common/createMicroApp/index';


Vue.prototype.$http = http;

Vue.prototype.common = common;
Vue.mixin(commonMixinx);
Vue.config.productionTip = false;

Vue.use(VueCookies);
Vue.use(globalComponents);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');


initMicroApp({
  router,
  Vue,
  // store
});
// 挂在到全局方便其它地方使用
// window.$vm = vm;
